/**
 * MAHI — minimal shell. Pure white + soft champagne wash + cyan ambient glow.
 * Used by every authenticated MAHI page.
 */
import React from 'react';

const MahiShell = ({ children, withGlow = true }) => (
  <div className="min-h-screen bg-white text-slate-900 antialiased relative overflow-hidden">
    {/* champagne / cyan ambient washes */}
    {withGlow && (
      <>
        <div className="pointer-events-none absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full"
             style={{ background: 'radial-gradient(circle, rgba(254,243,199,0.55) 0%, rgba(255,255,255,0) 70%)' }} />
        <div className="pointer-events-none absolute top-1/3 -right-32 w-[520px] h-[520px] rounded-full"
             style={{ background: 'radial-gradient(circle, rgba(165,243,252,0.45) 0%, rgba(255,255,255,0) 70%)' }} />
      </>
    )}
    <div className="relative">{children}</div>
  </div>
);

export default MahiShell;
